import { Component } from '@angular/core';
import { soundpostDimensionTypeEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Dimension Types') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostdimensiontype-form',
    templateUrl: './soundpostdimensiontype.form.component.html'
})
export class soundpostDimensionTypeFormComponent extends BaseFormComponent {
    public record!: soundpostDimensionTypeEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'accountingEntryLineDimensions', sectionName: 'Accounting Entry Line Dimensions', isExpanded: false },
            { sectionKey: 'postingGroupLineDimensions', sectionName: 'Posting Group Line Dimensions', isExpanded: false },
            { sectionKey: 'dimensions', sectionName: 'Dimensions', isExpanded: false },
            { sectionKey: 'productGLAccountDimensions', sectionName: 'Product GL Account Dimensions', isExpanded: false }
        ]);
    }
}

